import React from 'react';
import FooterOne from '../common/footer/FooterOne';
import HeaderOne from '../common/header/HeaderOne';
import SEO from '../common/SEO';
import BcrumbBannerOne from '../elements/breadcrumb/BcrumbBannerOne';
import CtaLayoutOne from '../component/cta/CtaLayoutOne';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import CaseStudyProp from '../component/casestudy/CaseStudyProp';
import { useLanguage } from '../context/LanguageContext';
import { Features } from '../assets/features/Features';


const CaseStudy = () => {
    const { language } = useLanguage();

    const TipsAnimation = () => (
        <div className="tips-animation">
            <svg viewBox="0 0 500 300" className="tips-svg">
                {/* Floating checklist */}
                <rect x="50" y="50" width="150" height="200" rx="10" fill="#fff" stroke="#333" strokeWidth="2" />
                <line x1="70" y1="80" x2="180" y2="80" stroke="#333" strokeWidth="2" strokeLinecap="round"/>
                <line x1="70" y1="110" x2="180" y2="110" stroke="#ccc" strokeWidth="2" strokeLinecap="round"/>
                <line x1="70" y1="140" x2="160" y2="140" stroke="#ccc" strokeWidth="2" strokeLinecap="round"/>
                <line x1="70" y1="170" x2="170" y2="170" stroke="#ccc" strokeWidth="2" strokeLinecap="round"/>
                
                {/* Check marks */}
                <path d="M160 80 L170 90 L190 70" stroke="#2ecc71" strokeWidth="3" fill="none" className="check-mark-1"/>
                
                {/* Floating Lightbulb */}
                <g className="lightbulb" transform="translate(250, 100)">
                    <path d="M30 0 A 30 30 0 1 0 30 60 L 30 80 L -30 80 L -30 60 A 30 30 0 1 0 -30 0 Z" fill="#f1c40f" opacity="0.8"/>
                    <rect x="-15" y="80" width="30" height="10" fill="#95a5a6"/>
                    <rect x="-15" y="92" width="30" height="10" fill="#95a5a6"/>
                    <circle cx="0" cy="110" r="5" fill="#95a5a6"/>
                    
                    {/* Glow lines */}
                    <line x1="0" y1="-40" x2="0" y2="-60" stroke="#f1c40f" strokeWidth="3" className="glow-line"/>
                    <line x1="40" y1="-30" x2="55" y2="-45" stroke="#f1c40f" strokeWidth="3" className="glow-line"/>
                    <line x1="-40" y1="-30" x2="-55" y2="-45" stroke="#f1c40f" strokeWidth="3" className="glow-line"/>
                </g>
            </svg>
            <style jsx>{`
                .tips-animation {
                    width: 100%;
                    height: 100%;
                    min-height: 300px;
                }
                .check-mark-1 {
                    stroke-dasharray: 50;
                    stroke-dashoffset: 50;
                    animation: checkDraw 2s ease-in-out infinite alternate;
                }
                @keyframes checkDraw {
                    to { stroke-dashoffset: 0; }
                }
                .lightbulb {
                    animation: bulbFloat 3s ease-in-out infinite;
                }
                @keyframes bulbFloat {
                    0%, 100% { transform: translate(250px, 100px); }
                    50% { transform: translate(250px, 80px); }
                }
                .glow-line {
                    animation: glowPulse 1.5s ease-in-out infinite alternate;
                }
                @keyframes glowPulse {
                    from { opacity: 0.3; }
                    to { opacity: 1; }
                }
            `}</style>
        </div>
    );

    return (
        <>
        <SEO title={Features.TIPS.TITLE[language]} />
        <ColorSwitcher />
            <main className="main-wrapper">
                <HeaderOne />
                <div className="breadcrum-area">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="section-heading heading-left">
                                    <h1 className="title h2">{Features.TIPS.TITLE[language]}</h1>
                                    <p>{Features.TIPS.SUBTITLE[language]}</p>
                                </div>
                            </div>
                            <div className="col-lg-6 d-none d-lg-block">
                                <TipsAnimation />
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="pt--100 pt_lg--100 pt_md--80 pt_sm--60 case-study-page-area">
                    <div className="container">
                        <CaseStudyProp />
                    </div>
                </div>
                <CtaLayoutOne />
                <FooterOne parentClass="" />
            </main>
        </>
    )
}

export default CaseStudy;